// import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

// Logo.propTypes = {
//   sx: PropTypes.object
// };

export default function Logo({ sx }) {
  const urlBaseImage = process.env.REACT_APP_BASE_NAME;
  return (
    // <RouterLink to="/">
      <Box
        component="img"
        src={`${urlBaseImage}/static/icons/new-icon-tecnozap.svg`}
        sx={{ width: 40, height: 40, ...sx }}
      />
    // </RouterLink>
  );
}
